import React from 'react';
import f1 from '../assets/f11.png'
import f2 from '../assets/f22.png'
import f3 from '../assets/f33.png'

const Offers = () => {
  return (
<div class="bg-custom-white p-4">
    <p className='text-center text-5xl text-custom-blue font-black py-12' >
            Lorem ipsum dolor sit amet consectetur on elit
    </p>
        
  <div class="inset-4 flex items-center justify-center bg-custom-blue">
      <div class="flex flex-col grid-cols-9 p-2 mx-auto md:grid">

        <div class="flex md:contents flex-row">
            <div class="relative p-4 my-6 text-gray-800 rounded-xl col-start-1 col-end-5 mr-auto md:mr-0 md:ml-auto">
                <img
                    alt='feature 1'
                    className='py-4'
                    src={f1}
                    style={{ maxWidth: '100%' }}
                />
            </div>
            <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto  flex items-center">
                <div>
                    <h3 class="text-lg font-semibold lg:text-xl text-center text-custom-white"> Feature 1</h3>
                    <p class="mt-2 leading-6 text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididun.</p>
                </div>
              </div>
        </div>


          <div class="flex md:contents">
            <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto  flex items-center">
              <div>
                  <h3 class="text-lg font-semibold lg:text-xl text-center text-custom-white"> Feature 2</h3>
                  <p class="mt-2 leading-6 text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididun.</p>
              </div>
              </div>

              <div class="relative px-4 my-6 text-gray-800  rounded-xl col-start-6 col-end-10 mr-auto">

                  <img
                    alt='feature 2'
                    className='py-4 '
                    src={f2}
                    style={{ maxWidth: '100%' }}
                  />
              </div>
          </div>

          <div class="flex md:contents flex-row">
              <div
                  class="relative px-4 my-6 text-gray-800  rounded-xl col-start-1 col-end-5 mr-auto md:mr-0 md:ml-auto">
                  <img
                    alt='feature 3'

                    className='py-4 '
                    src={f3}
                    style={{ maxWidth: '100%' }}
                  />
              </div>
              <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto  flex items-center">
                <div>
                    <h3 class="text-lg font-semibold lg:text-xl text-center text-custom-white"> Feature 3</h3>
                    <p class="mt-2 leading-6 text-center">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididun.</p>
                </div>
              </div>
          </div>



      </div>
    </div>
</div>
  );
};

export default Offers;
